import withStyles from '@material-ui/styles/withStyles';
import { DrcPanel } from 'driscolls-react-components';
import { default as React, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import DrcTab from '../../components/DrcTab/DrcTab';
import DispositionOptions from './DispositionOptions';
import GrowerPreferences from './GrowerPreferences';
import { setPageDirty, setPageTitleAction } from '../../actions/actions';
import { subTabDispositionRouting } from '../../util/navigation';
import DirtyCheck from '../../components/DirtyCheck';
import { withAuth } from '@driscollsinc/login-module-ui';

let styles = () => ({
    layout: {
        width: '97%'
    }
});

let changingTabIndex = 0;
let currentIndex = 0;

const Disposition = (props) => {
    const [screenHasDataChanges, setScreenHasDataChanges] = useState(false);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        let pageTitle = subTabDispositionRouting(pathname);
        props.setPageTitle(pageTitle);
    }, [pathname]);

    const continueNavigation = () => {
        currentIndex = changingTabIndex;
        if (changingTabIndex === 0) {
            navigate('/Disposition/DispositionOptions/');
            props.setPageTitle('Disposition Options');
        } else if (changingTabIndex === 1) {
            navigate('/Disposition/GrowerPreferences/');
            props.setPageTitle('Grower Preferences');
        }
    };

    const handleSubTabChange = (index) => {
        changingTabIndex = index;
        if (props.isPageDirty) {
            setScreenHasDataChanges(true);
            return;
        }
        currentIndex = index;
        continueNavigation();
    };

    const handleConfirmReject = () => {
        setScreenHasDataChanges(false);
        props.setPageDirty(false);
        continueNavigation();
    };

    const handleCancelNavigation = () => {
        setScreenHasDataChanges(false);
    };
    const { subTabItems, selectedSubTabIndex } = props;
    return (
        <DrcPanel
            style={{ maxWidth: '100%', border: 'none', boxShadow: '0 2px 4px 0 #C3C3C3', padding: '0 15px 5px', margin: '0 auto 5px' }}
            className={props.classes.layout}
        >
            <DrcTab
                style={{ maxWidth: '100%' }}
                selectedMenuIndex={selectedSubTabIndex}
                menuItems={subTabItems}
                handleMenuItemChange={handleSubTabChange}
                // centered
            ></DrcTab>

            {selectedSubTabIndex === 0 && <DispositionOptions />}
            {selectedSubTabIndex === 1 && <GrowerPreferences />}
            {screenHasDataChanges && (
                <DirtyCheck
                    screenHasDataChanges={screenHasDataChanges}
                    handleConfirmReject={handleConfirmReject}
                    handleCancelNavigation={handleCancelNavigation}
                ></DirtyCheck>
            )}
        </DrcPanel>
    );
};

const mapStateToProps = (state) => {
    return {
        isPageDirty: state.rootReducer.isPageDirty
    };
};

const mapDispatchToProps = (dispatch) => ({
    setPageDirty: (isDirty) => dispatch(setPageDirty(isDirty)),
    setPageTitle: (title) => dispatch(setPageTitleAction(title))
});

export default connect(mapStateToProps, mapDispatchToProps)(withAuth(withStyles(styles)(Disposition)));
